<template>
    <frame-list-view @detail="detail" filterable downloadable is-base-report/>
</template>

<script>
import ListView from '../../common/FrameListView';
import createView from '@baidu/ve-ria/views/createView';
import Model from './ListModel';

export default createView(ListView, Model, {
    methods: {
        detail(associatedId) {
            this.global.redirect({
                type: 'push',
                url: this.store.getDetailUrl({associatedId, associatedType: 'CARD'})
            });
        }
    }
});
</script>
